<template>
  <div>
    <svg
        :height='chartHeight'
        :width='chartWidth'
    >
    </svg>
  </div>
</template>

<script>
    import {select} from 'd3-selection';
    import {timeParse} from 'd3-time-format';
    import {scaleTime, scaleLinear} from 'd3-scale';
    import {line} from 'd3-shape';
    import {extent, max} from 'd3-array';
    import {axisBottom, axisLeft} from 'd3-axis';

    export default {
        name: 'PackChart',
        props: ['temperatureData','loading'],
        data() {
            return {
                margin: {top: 20, right: 20, bottom: 30, left: 60},
                height: 0,
                width: 0,
                chartWidth: 960,
                chartHeight: 500,
                chartX: null,
                chartY: null,
                chartSVG: {},
                chartData: [],
                parseTime: null,
                temperatureLine: {},
                humidityLine: {}
            }
        },
        created() {
            this.width = this.chartWidth - this.margin.left - this.margin.right;
            this.height = this.chartHeight - this.margin.top - this.margin.bottom;

            // set the ranges
            this.chartX = scaleTime().range([0, this.width]);
            this.chartY = scaleLinear().range([this.height, 0]);

            this.parseTime = timeParse('%Y');
        },
        mounted() {
            let x = this.chartX;
            let y = this.chartY;

            // append the svg object to the body of the page
            this.chartSVG = select('svg')
                .attr('width', this.width + this.margin.left + this.margin.right)
                .attr('height', this.height + this.margin.top + this.margin.bottom)
                .append('g')
                .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

            // define the line
            this.temperatureLine = line()
                .x(function (d) {
                    return x(d.date);
                })
                .y(function (d) {
                    return y(d.temperature);
                });
            // define the line
            this.humidityLine = line()
                .x(function (d) {
                    return x(d.date);
                })
                .y(function (d) {
                    return y(d.humidity);
                });
        },
        methods: {
            draw() {
                let x = this.chartX;
                let y = this.chartY;

                // format the data
                this.chartData.forEach(function (d) {
                    d.date = d.timestamp; //this.parseTime(d.date);
                    d.temperature = +d.temperature;
                    d.humidity = +d.humidity;
                });

                // sort years ascending
                this.chartData.sort(function (a, b) {
                    return a['timestamp'] - b['timestamp'];
                });
                // Scale the range of the data
                this.chartX.domain(extent(this.chartData, function (d) {
                    return d.date;
                }));
                this.chartY.domain([0, max(this.chartData, function (d) {
                    return Math.max(d.temperature, d.humidity);
                })]);

                // Add the valueline path.
                this.chartSVG.append('path')
                    .data([this.chartData])
                    .attr('class', 'line')
                    .attr('d', this.temperatureLine);
                // Add the valueline path.
                this.chartSVG.append('path')
                    .data([this.chartData])
                    .attr('class', 'line')
                    .style('stroke', 'red')
                    .attr('d', this.humidityLine);
                // Add the X Axis
                this.chartSVG.append('g')
                    .attr('transform', 'translate(0,' + this.height + ')')
                    .call(axisBottom(x));

                // Add the Y Axis
                this.chartSVG.append('g')
                    .call(axisLeft(y));
            }
        },
        watch: {
            temperatureData() {
                this.chartData = this.temperatureData;
            },
            loading() {
                this.draw();
            }
        },
        computed: {}
    };

    /*
    var svg = d3.select('svg'),
        margin = {top: 20, right: 20, bottom: 30, left: 60},
        width = +svg.attr('width') - margin.left - margin.right,
        height = +svg.attr('height') - margin.top - margin.bottom,
        g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    var parseDate = d3.timeParse('%Y-%m-%d'),
        formatDate = d3.timeFormat('%Y');

    var x = d3.scaleTime()
        .domain([new Date(1999, 0, 1), new Date(2003, 0, 0)])
        .range([0, width]);

    var y = d3.scaleLinear()
        .range([height, 0]);

    var xAxis = d3.axisBottom(x);

    var yAxis = d3.axisLeft(y);

    var area = d3.area()
        .curve(d3.curveStepAfter)
        .y0(y(0))
        .y1(function(d) { return y(d.value); });

    var areaPath = g.append('path')
        .attr('clip-path', 'url(#clip)')
        .attr('fill', 'steelblue');

    var yGroup = g.append('g');

    var xGroup = g.append('g')
        .attr('transform', 'translate(0,' + height + ')');

    var zoom = d3.zoom()
        .scaleExtent([1 / 4, 8])
        .translateExtent([[-width, -Infinity], [2 * width, Infinity]])
        .on('zoom', zoomed);

    var zoomRect = svg.append('rect')
        .attr('width', width)
        .attr('height', height)
        .attr('fill', 'none')
        .attr('pointer-events', 'all')
        .call(zoom);

    g.append('clipPath')
        .attr('id', 'clip')
        .append('rect')
        .attr('width', width)
        .attr('height', height);

    d3.csv('flights.csv', function(d) {
        d.date = parseDate(d.date);
        d.value = +d.value;
        return d;
    }, function(error, data) {
        if (error) throw error;
        var xExtent = d3.extent(data, function(d) { return d.date; });
        zoom.translateExtent([[x(xExtent[0]), -Infinity], [x(xExtent[1]), Infinity]])
        y.domain([0, d3.max(data, function(d) { return d.value; })]);
        yGroup.call(yAxis).select('.domain').remove();
        areaPath.datum(data);
        zoomRect.call(zoom.transform, d3.zoomIdentity);
    });

    function zoomed() {
        var xz = d3.event.transform.rescaleX(x);
        xGroup.call(xAxis.scale(xz));
        areaPath.attr('d', area.x(function(d) { return xz(d.date); }));
    }
*/
</script>

<style>
  .line {
    fill: none;
    stroke: steelblue;
    stroke-width: 2px;
  }
</style>

